import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import LocationsSlider from '../Elements/LocationsSlider';

/**
 * Location Controller
 *
 * @class
 */
class LocationController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(...LocationsSlider);
  }
}

export default new LocationController();
